import React, { Fragment } from "react";
import get from "lodash/get";
import { useFormikContext } from "formik";
import ReactToggle from "react-toggle";
import { getToggleProps } from "utils/form";

const DEFAULT_LABEL = "Required";
const DEFAULT_DESCRIPTION = "Must have value to complete checkout.";

const Toggle = ({
  name,
  label = DEFAULT_LABEL,
  description = DEFAULT_DESCRIPTION
}) => {
  const {
    values,
    touched,
    setFieldValue,
    setFieldTouched
  } = useFormikContext();

  const activeValue = Boolean(get(values, name));

  return (
    <Fragment>
      <div className="w-100 flex flex-column">
        <div className="w-100 flex flex-row justify-between items-center">
          <label className="f6 dib fw6">{label}</label>
          <ReactToggle
            {...getToggleProps({
              active: activeValue,
              setFieldValue: (_, active) => {
                setFieldValue(name, active);
                if (!get(name, touched)) {
                  setFieldTouched(name, true);
                }
              }
            })}
          />
        </div>
        <div className="f6 pt2">{description}</div>
      </div>
    </Fragment>
  );
};

export default Toggle;
